import styled from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";

export const Wrapper = styled.div`
    display: inline-block;
    position: relative;
    align-self: center;
    max-width: 100%;

    @media ${getBreakpoint("down", "lg")} {
        display: flex;
        width: 100%;
    }
`;

export const Pill = styled.div`
    @media ${getBreakpoint("down", "lg")} {
        display: none;
    }
`;

export const Popup = styled.div<{ hasNavOffset?: boolean; isFixed?: boolean }>`
    position: fixed;
    top: ${({ hasNavOffset, isFixed }) =>
        `calc(${hasNavOffset ? "var(--visibleHeaderHeight, 0)" : "0px"} + ${isFixed ? 76 : `${theme.space[6]}`}px)`}; /* TopOffset of sticky bar + height of sticky bar */
    left: ${theme.space[2]}px;
    right: ${theme.space[2]}px;
    min-width: 50vw;
    background-color: ${theme.colors.primaryWhite};
    border: 1px solid ${theme.colors.grey2};
    border-radius: 8px;
    z-index: ${theme.zIndex.popover};

    @media ${getBreakpoint("up", "md")} {
        left: auto;
    }

    @media ${getBreakpoint("up", "lg")} {
        position: absolute;
        top: 66px; /* 40 (height button) + 24 (spacing) */
        left: auto;
        right: ${theme.space[1]}px;
        min-width: 256px;
    }

    &[data-browser-is-zoomed="true"] {
        position: static;
        top: auto;
    }

    html[dir="rtl"] & {
        @media ${getBreakpoint("up", "md")} {
            left: ${theme.space[2]}px;
            right: auto;
        }
        @media ${getBreakpoint("up", "lg")} {
            left: ${theme.space[1]}px;
            right: auto;
        }
    }
`;
